import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod";

export const getTeamLocations = {
  name: "getTeamLocations" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
